import * as Yup from 'yup';

export const FolderSchema = Yup.object().shape({
  folderName: Yup.string()
    .required('Folder name is required')
    .max(30, 'Folder name must be 30 characters or less')
    .trim(),
});
